import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sunbedSelect", "preparationInput"]
  static values = { 
    sunbedData: Object,
    currentDuration: Number
  }

  connect() {
    console.log("SunbedDurationController connected")
    this.lastPreparationValue = null
    this.updateDurationOptions()
  }

  sunbedChanged() {
    this.updateDurationOptions()
  }

  updateDurationOptions() {
    console.log("Updating duration options")
    const sunbedId = this.sunbedSelectTarget.value
    console.log("Selected sunbed ID:", sunbedId)
    
    // Trouver le select component de durée
    // Chercher le select qui a name="appointment[duration_minutes]"
    const durationSelect = this.element.querySelector('select[name*="duration_minutes"]')
    if (!durationSelect) {
      console.log("Duration select not found")
      console.log("Available selects:", this.element.querySelectorAll('select'))
      return
    }
    
    // Trouver le parent div qui contient le contrôleur select
    const durationSelectComponent = durationSelect.closest('[data-controller*="select"]')
    if (!durationSelectComponent) {
      console.log("Duration select component not found")
      return
    }

    // Le select caché est celui qu'on a déjà trouvé
    const hiddenSelect = durationSelect
    
    // Trouver le dropdown des options
    const dropdown = durationSelectComponent.querySelector('[data-select-target="dropdown"]')
    if (!dropdown) {
      console.log("Dropdown not found")
      return
    }
    
    // Vider le select caché et le dropdown
    hiddenSelect.innerHTML = ''
    dropdown.innerHTML = ''
    
    if (!sunbedId || !this.sunbedDataValue[sunbedId]) {
      console.log("No sunbed selected or no data found")
      // Réinitialiser le champ de préparation
      if (this.hasPreparationInputTarget) {
        this.preparationInputTarget.value = ''
        this.preparationInputTarget.placeholder = 'Ex: 10'
      }
      return
    }

    const sunbedData = this.sunbedDataValue[sunbedId]
    const prices = sunbedData.prices || {}
    const preparationDuration = sunbedData.preparation_duration || 0
    
    // Mettre à jour le champ de préparation
    if (this.hasPreparationInputTarget) {
      // Si le champ est vide ou a la valeur par défaut précédente, le remplir avec la valeur du banc
      if (!this.preparationInputTarget.value || this.preparationInputTarget.value === this.lastPreparationValue) {
        this.preparationInputTarget.value = preparationDuration
      }
      this.preparationInputTarget.placeholder = `Défaut: ${preparationDuration} min`
      this.lastPreparationValue = preparationDuration
    }
    const durations = Object.keys(prices).map(d => parseInt(d)).sort((a, b) => a - b)
    console.log("Available durations:", durations)
    
    // Ajouter la valeur actuelle si elle n'est pas dans les durées disponibles
    const currentValue = this.currentDurationValue
    if (currentValue && !durations.includes(currentValue)) {
      durations.push(currentValue)
      durations.sort((a, b) => a - b)
      console.log("Added current duration to available options:", currentValue)
    }
    
    durations.forEach((duration, index) => {
      const price = prices[duration]
      const text = price ? `${duration} minutes (${price}€)` : `${duration} minutes`
      
      // Ajouter l'option au select caché
      const option = document.createElement('option')
      option.value = duration
      option.textContent = text
      
      hiddenSelect.appendChild(option)
      
      // Créer l'option dans le dropdown
      const dropdownOption = document.createElement('div')
      dropdownOption.setAttribute('data-select-target', 'option')
      dropdownOption.setAttribute('data-action', 'click->select#selectOption')
      dropdownOption.setAttribute('data-value', duration)
      dropdownOption.setAttribute('data-title', text)
      dropdownOption.className = 'py-2 px-3 w-full text-sm text-gray-800 cursor-pointer hover:bg-gray-100 rounded-md focus:outline-none focus:bg-gray-100'
      dropdownOption.innerHTML = `
        <div class="flex items-center">
          <div class="flex-1">
            <div class="text-sm text-gray-800" data-title>${text}</div>
          </div>
          <div class="ms-auto">
            <span class="hidden" data-select-target="checkIcon">
              <svg class="shrink-0 size-4 text-green-600" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="20,6 9,17 4,12"></polyline>
              </svg>
            </span>
          </div>
        </div>
      `
      dropdown.appendChild(dropdownOption)
    })
    
    // Si on a des durées, sélectionner la première par défaut ou la valeur existante
    if (durations.length > 0) {
      // Attendre un peu pour que le DOM soit mis à jour
      setTimeout(() => {
        // Récupérer la valeur actuelle du rendez-vous
        const currentValue = this.currentDurationValue || hiddenSelect.value
        
        console.log("Current value from Stimulus:", this.currentDurationValue)
        console.log("Current value from select:", hiddenSelect.value)
        console.log("Available durations:", durations)
        
        let durationToSelect = durations[0] // Par défaut, la plus petite durée
        
        // Si on a une valeur actuelle qui correspond à une durée disponible, l'utiliser
        if (currentValue && durations.includes(parseInt(currentValue))) {
          durationToSelect = parseInt(currentValue)
          console.log("Using current value:", durationToSelect)
        } else {
          console.log("Using default duration:", durationToSelect)
        }
        
        const optionToSelect = dropdown.querySelector(`[data-value="${durationToSelect}"]`)
        if (optionToSelect) {
          console.log("Selecting option:", optionToSelect)
          // Simuler un clic sur l'option pour la sélectionner
          optionToSelect.click()
        } else {
          console.log("Option to select not found in dropdown")
        }
      }, 10)
    }
    
    console.log("Duration options updated")
  }
}
